<vo-vm-theme-provider>
  <div class="app">
    <div id="tlp-hdr-bg">
      <vm-header-wrapper [class.is-loading]="isLoading" [variant]="themeVariant" vmRemoveFromView></vm-header-wrapper>
    </div>
    <main class="main">
      <router-outlet></router-outlet>
    </main>
    <div [class.is-loading]="isLoading" class="feedbackButton" id="feedbackButton"></div>
    <vo-smart-footer [class.is-loading]="isLoading" [links]="smartFooter?.links" [logo]="smartFooter?.logo"></vo-smart-footer>
  </div>
</vo-vm-theme-provider>
